import Vue from "vue"

export const educationLevelStore = {
  state: {
    edu_forms: [],
    campaign: {},
    generated_at: '',
    contest_groups: [],
    total: {}
  },
  mutations: {
    SET_CAMPAIGN(state, campaign) {
      Vue.set(state, 'campaign', campaign)
    },
    SET_EDU_FORMS(state, edu_forms) {
      Vue.set(state, 'edu_forms', edu_forms)
    },
    SET_CONTEST_GROUPS(state, contest_groups) {
      Vue.set(state, 'contest_groups', contest_groups)
    },
    SET_GENERATED_AT(state, generated_at) {
      Vue.set(state, 'generated_at', generated_at)
    },
    SET_TOTAL(state, total) {
      Vue.set(state, 'total', total)
    }
  },
  actions: {
    async getEducationLevel({ commit }, {education_level, edu_form}) {
      try {
        const data = await Vue.http.get(`/api/v1/campaigns/${education_level}/${edu_form}`)
        commit('SET_CAMPAIGN', data.body.campaign)
        commit('SET_EDU_FORMS', data.body.edu_forms)
        commit('SET_CONTEST_GROUPS', data.body.contest_groups)
        commit('SET_GENERATED_AT', data.body.generated_at)
        commit('SET_TOTAL', data.body.total)
        return data
      } catch(error) {
        throw error
      }
    }
  }
}